import React, { useState } from "react";
import BasicInformationForm from "./BasicInformationForm";
import PersonalInformationForm from "./PersonalInformationForm";
import DocumentVerification from "./DocumentVerification";
import BankingInfoForm from "./BankingInfoForm";
import { createData } from "../../../utility/adminApi.js";
import { useQuery } from "@tanstack/react-query";

function Kyc() {
  const [isLoanRequest] = useState(() => {
    return sessionStorage.getItem("isAccepted") === "true" ? true : false;
  });
  const [step, setStep] = useState(0);
  const [modal, setModal] = useState(false);
  const [formData, setFormData] = useState(() => {
    const storedFormData = sessionStorage.getItem("form");
    return storedFormData ? JSON.parse(storedFormData) : {}; // Parse JSON if exists
  });

  const stepTitles = [
    "Basic Business Information",
    "Owner's Personal Information",
    "Financial and Banking Information",
    "Document Verification",
  ];
  const totalSteps = stepTitles.length;

  const handleNext = () => {
    sessionStorage.setItem("form", JSON.stringify(formData));
    if (step < totalSteps - 1) setStep(step + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const response = await createData("loans/store", formData);
    // console.log(response);
  };

  const handleBack = () => {
    if (step > 0) setStep(step - 1);
  };

  if (!isLoanRequest) {
    return (
      <div className="w-full bg-white mx-auto p-4">
        <h2>Request a new Loan to Access</h2>
      </div>
    );
  }
  return (
    <div className="w-full bg-white mx-auto p-4">
      {/* Step Indicators */}
      <div className="flex justify-center mb-4">
        {stepTitles.map((_, idx) => (
          <div
            key={idx}
            className={`h-3 w-3 mx-1 rounded-full ${
              idx <= step ? "bg-blue-600" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>

      {/* Title */}
      <div>
        <h2 className="text-xl font-semibold mb-4">{stepTitles[step]}</h2>

        {/* Step Form Fields */}
        {step === 0 && (
          <BasicInformationForm
            formData={formData}
            setFormData={setFormData}
            handleNext={handleNext}
          />
        )}

        {step === 1 && (
          <PersonalInformationForm
            formData={formData}
            setFormData={setFormData}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        )}

        {step === 2 && (
          <BankingInfoForm
            handleBack={handleBack}
            handleNext={handleNext}
            formData={formData}
            setFormData={setFormData}
          />
        )}

        {step === 3 && (
          <DocumentVerification
            formData={formData}
            setFormData={setFormData}
            setModal={setModal}
            handleBack={handleBack}
          />
        )}
      </div>
    </div>
  );
}

export default Kyc;
